/**
 * @generated SignedSource<<6e812e9335fc2e8a13d4762b098a13cb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CalendarSyncStatus = {
  calendarId?: string | null;
  syncEnabled?: boolean | null;
};
export type UserPreferencesSetSyncedCalendarsMutation$variables = {
  syncFlags: ReadonlyArray<CalendarSyncStatus>;
};
export type UserPreferencesSetSyncedCalendarsMutation$data = {
  readonly setCalendarsSyncStatus: {
    readonly calendars: ReadonlyArray<{
      readonly id: string;
      readonly syncEnabled: boolean;
    } | null>;
    readonly ok: boolean;
  } | null;
};
export type UserPreferencesSetSyncedCalendarsMutation = {
  response: UserPreferencesSetSyncedCalendarsMutation$data;
  variables: UserPreferencesSetSyncedCalendarsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "syncFlags"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "syncFlags",
        "variableName": "syncFlags"
      }
    ],
    "concreteType": "SetCalendarsSyncStatus",
    "kind": "LinkedField",
    "name": "setCalendarsSyncStatus",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Calendar",
        "kind": "LinkedField",
        "name": "calendars",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "syncEnabled",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UserPreferencesSetSyncedCalendarsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UserPreferencesSetSyncedCalendarsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "32155fe847c1f1f4f60bae3eb841a478",
    "id": null,
    "metadata": {},
    "name": "UserPreferencesSetSyncedCalendarsMutation",
    "operationKind": "mutation",
    "text": "mutation UserPreferencesSetSyncedCalendarsMutation(\n  $syncFlags: [CalendarSyncStatus!]!\n) {\n  setCalendarsSyncStatus(syncFlags: $syncFlags) {\n    ok\n    calendars {\n      id\n      syncEnabled\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2fa9460f3820cefaba997773cf1540db";

export default node;
